export default __webpack_public_path__ + "static/media/share_email_icon.5e84f4e1.png";